import { getStoredData, get_auth_key } from '../util';

export const isAdmin = () => {
  const storedData = JSON.parse(getStoredData(get_auth_key()));
  return ['admin', 'super-admin', 'inventory-admin'].includes(storedData.role);
};
